import React from 'react';
import "./success.css";
import Button from '../../components/button/Button';

const Success = () => {
  return (
    <div className='success-container'>
      <div className="button-container">
        <Button route="/" text="Inicio" />
        <Button route="/brands" text="Marcas" />
      </div>

      <p className="success-title">Gracias por su compra! Verifique su correo para obtener el link de descarga.</p>
    </div>
  )
}

export default Success